import { gsap } from "gsap";
import { CustomEase } from "gsap/all";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import barba from "@barba/core";

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(CustomEase);

const rollupEase = CustomEase.create("custom", ".25,.666,0,1 ");

const Animations = ($, context, routerInit) => {
  const animateOnScroll = () => {
    const onScrollAnimatedElements = gsap.utils.toArray('.animateOnScroll');

    onScrollAnimatedElements.forEach((thisEl, i) => {
        ScrollTrigger.create({
          start: "top 90%",
          trigger: thisEl,
          onEnter: () => thisEl.classList.add('revealed'),
          // onLeave: () => thisEl.classList.remove('revealed'),
          // onEnterBack: () => thisEl.classList.add('revealed'),
          onLeaveBack: () => thisEl.classList.remove('revealed'),
        });
      });
  };

  const animateLanding = () => {
    const $curtain = $("#landing-curtain");
    const $logoTarget = $("#top-nav .logo");

    const curtainAnimationProps = { duration: 2, ease: rollupEase };
    const curtainLogoAnimationProps = { duration: 3, ease: rollupEase };

    /* Landing curtain element is present? Animate */
    if ($curtain.size() > 0) {
      /* Hide the top nav logo while the curtain animation is going*/
      $logoTarget.prop("opacity", 0);

      /* Get target position and size for logo */
      const offset = $logoTarget.offset(),
        targetWidth = $logoTarget.width(),
        startWidth = $(".logo_landingCurtain > svg").width();

      /* Animate */
      gsap
        .timeline({
          onComplete: () => {
            /* Remove animation initial state class from body tag */
            $("body").removeClass("landing-curtain");

            /* Make sure the curtain is removed so it doesn't retrigger after pjax page change */
            $curtain.remove();
          },
        })
        .set(".logo_topNav", { opacity: 0 }, "beginning")
        .addLabel("curtainOut", "+=.3")
        .to(
          "#landing-curtain",
          { backgroundColor: "rgba(132, 38, 178, 0)", ...curtainLogoAnimationProps },
          "curtainOut"
        )
        .fromTo(
          ".logo_landingCurtain > svg",
          { width: startWidth },
          { width: targetWidth, top: offset.top, left: offset.left, ...curtainAnimationProps },
          "curtainOut"
        )
        .to(
          ".logo_landingCurtain > svg > path",
          { fill: "#000000", ...curtainAnimationProps },
          "curtainOut"
        )

        .addLabel("end")
        .set(".logo_topNav", { opacity: 1 }, "end")
        .to("#landing-curtain", { visibility: "hidden" }, "end");
    }
  };

  // For page load animations.
  const initializeAnimations = () => {
    const bodyEl = $('body');
    if(bodyEl.hasClass('animationTrigger')) {
      $('body').removeClass("animationTrigger");
      // slight delay helps css paint issues
      setTimeout(()=>{
        $('body').addClass("animationTrigger");
      }, 10);
    } else {
      $('body').addClass("animationTrigger");
    }
  }

  const pageTransitions = () => {
    const duration = 0.667;
    var z = 2000;

    // html head parser borrowed from jquery pjax
    const updateHeader = data => {
      var $newPageHead = $("<head />").html(
        $.parseHTML(data.html.match(/<head[^>]*>([\s\S.]*)<\/head>/i)[0], document, true)
      );
      var headTags = [
        "meta[name='keywords']",
        "meta[name='description']",
        "meta[property^='og']",
        "meta[name^='twitter']",
        "meta[itemprop]",
        "link[itemprop]",
        "link[rel='prev']",
        "link[rel='next']",
        "link[rel='canonical']",
      ].join(",");
      $("head").find(headTags).remove(); // Remove current head tags
      $newPageHead.find(headTags).appendTo("head"); // Append new tags to the head
    };

    // console.log("Init barba")
    barba.init({
      prevent: ({ el }) => {
        // console.log(el, $(el).parents('nav'), $(el).parents('nav').length)
        return !$(el).parents("nav#full-nav").length;
        // return false
      },
      transitions: [
        {
          name: "opacity-transition",
          sync: true,
          debug: true,

          leave(data) {
            const done = this.async();
            const $fullNav = $("#full-nav", data.current.container);

            // $(data.current.container).css({overflowY: 'hidden', maxHeight: '100vh'})
            $fullNav.css({ overflow: "hidden" });

            gsap
              .timeline({
                onComplete: done,
              })
              .to($fullNav[0], { y: -100, duration: duration });
          },
          enter(data) {
            // return gsap
            //   .set(data.next.container, { position: 'fixed', top: '100%' })
            //   .to(data.next.container, { top: '0', duration: 1000 })
            //   .set(data.next.container, { position: 'relative' })

            // console.log(data.next.container)

            const done = this.async();
            gsap
              .timeline({
                onComplete: () => {
                  $(data.next.container).removeAttr("style");
                  // window.scrollTo(0,0);
                  window.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: "instant",
                  });
                  done();
                },
              })
              .set(data.next.container, { position: "fixed", top: "100%", zIndex: z++ })
              .to(data.next.container, {
                top: $(data.current.container).offset().top,
                duration: duration
              });
            // .set(data.next.container, { position: 'relative' })

            // return gsap.from(data.next.container, {
            //   opacity: 0, duration: 1000,
            // });
            // console.log("ENTER")

            // console.log("Reinit router")
            // routerInit(data.next.container)
          },
          before(data) {
            /* Make sure we remove the landing curtain when navigating with ajax */
            $("#landing-curtain", data.next.container).remove();
            initializeAnimations();
          },
          after(data) {
            // routerInit()
            updateHeader(data.next);
            routerInit(data.next.container);
          },
        },
      ],
    });
  };

  var self = {
    init: () => {
      initializeAnimations();
      animateLanding();
      // animateText();
      // animateImages();
      animateOnScroll();

      if (!barbaInitalized) {
        barbaInitalized = true;
        pageTransitions();
      }
    },
  };

  return self;
};

let barbaInitalized = false;

export default Animations;
